import { render, staticRenderFns } from "./PatientDataStep.vue?vue&type=template&id=6ec45996&scoped=true"
import script from "./PatientDataStep.vue?vue&type=script&lang=js"
export * from "./PatientDataStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec45996",
  null
  
)

export default component.exports